import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSubeler, girisYap } from '../services/api';

export default function Login() {
  const navigate = useNavigate();
  const [subeler, setSubeler] = useState([]);
  const [seciliSube, setSeciliSube] = useState('');
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(true);
  const [girisYapiliyor, setGirisYapiliyor] = useState(false);

  useEffect(() => {
    getSubeler()
      .then(res => setSubeler(res.data))
      .catch(() => setHata('Şube listesi alınamadı. API çalışıyor mu?'))
      .finally(() => setYukleniyor(false));
  }, []);

  const handleGiris = async (e) => {
    e.preventDefault();
    setHata('');
    if (!seciliSube) { setHata('Lütfen şube seçiniz.'); return; }
    if (!kullaniciAdi || !sifre) { setHata('Lütfen kullanıcı adı ve şifrenizi giriniz.'); return; }

    // Şube kodu önce yazılır ki API isteği doğru veritabanına yönlensin (X-Sube-Kod header'ı).
    localStorage.setItem('subeKod', seciliSube);
    // Şube ADI üst şeritte gösteriliyor; kod ("SANCAKTEPE") değil tam adı yazılsın.
    localStorage.setItem('subeAdi', subeler.find(s => s.kod === seciliSube)?.adi || seciliSube);

    setGirisYapiliyor(true);
    try {
      const res = await girisYap(kullaniciAdi, sifre);
      const { jeton, ...kullanici } = res.data;
      // Jeton ayrı tutulur; her istekte Authorization başlığına konur (bkz. services/api.js).
      localStorage.setItem('jeton', jeton);
      localStorage.setItem('kullanici', JSON.stringify(kullanici));
      navigate('/', { replace: true });
    } catch (err) {
      localStorage.removeItem('subeKod');
      localStorage.removeItem('jeton');
      setHata(err.response?.data?.hata || 'Kullanıcı Adı ve Şifrenizi Kontrol Ediniz');
    } finally {
      setGirisYapiliyor(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #e8f4f8 0%, #f0eaff 50%, #eafaf1 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 24
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>

        {/* Logo — kurumsal logo public/fizyologo.png içindedir. Görselin kendisi zaten
            "FIZYOFIPLUS" yazısını taşıdığı için altına metin başlık/alt yazı konmuyor;
            logo doğrudan giriş kartının üstünde durur (kullanıcı talebi: 2026-08-20). */}
        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          <img
            src={`${process.env.PUBLIC_URL}/fizyologo.png`}
            alt="FizyofiPlus"
            style={{ width: 210, maxWidth: '100%', height: 'auto', display: 'block', margin: '0 auto' }}
          />
        </div>

        {/* Kart */}
        <div style={{
          background: '#fff', borderRadius: 18,
          boxShadow: '0 8px 32px rgba(100,80,200,.12)',
          overflow: 'hidden'
        }}>
          {/* Başlık */}
          <div style={{ background: 'linear-gradient(135deg, #7C5CBF, #1D9E75)', padding: '18px 24px' }}>
            <div style={{ color: '#fff', fontSize: 17, fontWeight: 700 }}>🔐 Sisteme Giriş</div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 3 }}>Şubenizi seçip kullanıcı bilgilerinizle giriş yapın</div>
          </div>

          {/* Form */}
          <form onSubmit={handleGiris} style={{ padding: '22px 24px' }}>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Şube
              </label>
              <select
                value={seciliSube}
                onChange={e => setSeciliSube(e.target.value)}
                required
                disabled={yukleniyor}
                style={{ border: '1.5px solid #c5b3f0', borderRadius: 8, background: '#faf8ff', color: '#3d2f6e', fontWeight: 500 }}
              >
                <option value="">LÜTFEN SEÇİNİZ</option>
                {subeler.map(s => (
                  <option key={s.kod} value={s.kod}>{s.adi}</option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Kullanıcı Adı
              </label>
              <input
                type="text"
                value={kullaniciAdi}
                onChange={e => setKullaniciAdi(e.target.value)}
                required
                style={{ border: '1.5px solid #c5b3f0', borderRadius: 8, background: '#faf8ff', color: '#3d2f6e' }}
              />
            </div>

            <div style={{ marginBottom: 22 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Şifre
              </label>
              <input
                type="password"
                value={sifre}
                onChange={e => setSifre(e.target.value)}
                required
                style={{ border: '1.5px solid #c5b3f0', borderRadius: 8, background: '#faf8ff', color: '#3d2f6e' }}
              />
            </div>

            {hata && (
              <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
                {hata}
              </div>
            )}

            <button
              type="submit"
              disabled={girisYapiliyor}
              style={{
                width: '100%', padding: '13px',
                background: 'linear-gradient(135deg, #7C5CBF, #a07de0)',
                color: '#fff', border: 'none', borderRadius: 10,
                fontSize: 15, fontWeight: 700, cursor: girisYapiliyor ? 'default' : 'pointer',
                boxShadow: '0 4px 12px rgba(124,92,191,.35)',
                opacity: girisYapiliyor ? 0.7 : 1,
              }}
            >
              {girisYapiliyor ? 'GİRİŞ YAPILIYOR...' : '🔐 GİRİŞ YAP'}
            </button>

            {/* Uygulama /webpro altında çalıştığı için react-router'ın Link'i işe yaramaz;
                kurumsal siteye çıkış tam adresle yapılır. */}
            <a
              href="https://www.fizyofiplus.online"
              style={{
                display: 'block', width: '100%', padding: '12px', marginTop: 10,
                background: '#fff', color: '#7C5CBF',
                border: '1.5px solid #c5b3f0', borderRadius: 10,
                fontSize: 14, fontWeight: 700, textAlign: 'center',
                textDecoration: 'none', boxSizing: 'border-box',
              }}
            >
              🏠 ANA SAYFAYA DÖN
            </a>

          </form>
        </div>
      </div>
    </div>
  );
}
